import moment from 'moment'

import { getTimeSpan } from 'shared/time-utilites'

export const DATE_TIME_RANGE_SET = 'DATE_TIME_RANGE_SET'
export const ADJUST_DATE_TIME_RANGE = 'ADJUST_DATE_TIME_RANGE_FOR_SUBSCRIPTION'

export const setDateTimeRange = (start, end) => ({
    type: DATE_TIME_RANGE_SET,
    start,
    end,
})

export const adjustDateTimeRangeForSubscription = () => ({
    type: ADJUST_DATE_TIME_RANGE,
})

export function reducer(state = getTimeSpan(moment(), 30, 120), action) {
    const { type, start, end } = action
    switch (type) {
        case DATE_TIME_RANGE_SET:
            return {
                start,
                end,
            }
        case ADJUST_DATE_TIME_RANGE:
            return !state.start.isAfter(moment().add(1, 'weeks'), 'day')
                ? getTimeSpan(moment().add(1, 'weeks'), 30, 120)
                : state
        default:
            state
    }
    return type === DATE_TIME_RANGE_SET ? { start, end } : state
}

export const searchDateTimeSelector = state => state.searchDateTime

export default {
    reducers: {
        searchDateTime: reducer,
    },
    searchDateTimeSelector,
    setDateTimeRange,
}
